import { useEffect, useState } from "react";
import { useHandleInputChange } from "../hooks/useHandleInputChange";
import { _zzsurvey_dummy_res_v1, _zzsurvey_utils_demo_res_v2_make } from "../utils/zz/zz-zzsurvey-dummy";
import { _zzsurvey_formDefiinitionSingleQuestion_make, _zzsurvey_utils_quizEditorState_initial_blank_make, _zzsurvey_utils_dummyResPayload_v1_to_quizEditorState, _zzsurvey_utils_initial_singleQuestionState_make, _zzsurvey_utils_quizEditorState_to_quizBlueprint_preview, _zzsurvey_utils_singleQuestionState_to_extra_answer_props, _zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint, _zzsurvey_utils_backendQuizBlueprint_to_quizEditorState } from "../utils/zz/zz-zzsurvey-quiz-utils";
import { _zzsurvey_formDefiinitionSurveyHeader } from "../utils/zz/zz-zzsurvey-utils";
import Btn from "./Btn";
import FormFieldGenerator from "./FormFieldGenerator";
import FormGenerator from "./FormGenerator";
import ZZTempSurveyQuizFill from "./ZZTempSurveyQuizFill";


//
const config_condition_feature_enabled = false; //


//
const _prepare_for_submit_questions = (editorQuizState) => {
  console.log('_prepare_for_submit_questions(editorQuizState)', editorQuizState);
  //
  /*
  {
    "title": "Please fill our survey.",
    "date_due": "2027-02-15",
    "questions": [
    {
        "title": "What is the meaning of life?",
        "question_type": "text"
    },
        {
        "title": "Are you happy?",
        "question_type": "yesno"
    },
    {
        "title": "What is your favourite color?",
        "question_type": "abc",
        "a":"Blue",
        "b":"Green",
        "c":"Yellow",
  */
  const prepared = {
    internal_name: editorQuizState.header.internal_name,
    title: editorQuizState.header.title,
    // survey_text: editorQuizState.header.survey_text,
    text: editorQuizState.header.survey_text,
    // img_url: editorQuizState.header.survey_img_src,
    img_src: editorQuizState.header.survey_img_src,
    // date_due: null, // TODO
    // date_due: '2027-12-31', // TODO
    // date_due: editorQuizState.header.date_due, // TODO
    service_type: editorQuizState.header.service_type, // NEW
    first_email_title: editorQuizState.header.first_email_title,
    first_email_content: editorQuizState.header.first_email_content,
    second_email_title: editorQuizState.header.second_email_title,
    second_email_content: editorQuizState.header.second_email_content,
    is_review: editorQuizState.header.is_review,
    //
    questions: [],
  };
  if (editorQuizState.header.is_review) {
    prepared.review_text = editorQuizState.header.review_text;
    prepared.review_link = editorQuizState.header.review_link;
  }
  prepared.questions = editorQuizState.questions.map((q, index) => {
    // const key = item.question_id;
    // const question = q;
    let question_type = q.question_type;
    let required = false;
    if (typeof q.required === 'boolean') {
      required = q.required;
    }
    let backendizedQProps = {};
    if (question_type === "TEXT") { /* do nothing */ }
    if (question_type === "YES_NO") { /* do nothing */ }
    if (question_type === "STARS_5") { /* do nothing */ }
    if (question_type === "SCALE_5") {
      // TODO
      /*
      {
          "question_id": 4,
          "q": {
              "question_id": 4,
              "question_type": "SCALE_5",
              "title": "Neki scale",
              "a": null,
              "b": null,
              "c": null,
              "d": null,
              "e": null,
              "f": null,
              "g": null,
              "h": null,
              "i": null,
              "j": null,
              "opt_scale100": null,
              "opt_scale75": null,
              "opt_scale50": null,
              "opt_scale25": null,
              "opt_scale0": null,
              "checklist": null,
              "extra_answer_enabled": false,
              "extra_answer_required": null,
              "extra_question_title": null,
              "extra_answer_condition": null,
              "answer": null
          },
          "answer_main": null,
          "answer_extra": null
      }
      */
      /*
      singleQuestionState.question_option_titles = { // DEFAULTS
        "100": "Almost certain", // u tabeli questions ovo polja nazvati opt_scale100
        "75": "Highly likely", // u tabeli questions ovo polja nazvati opt_scale75
        "50": "Likely/probable", // u tabeli questions ovo polja nazvati opt_scale50
        "25": "Unlikely", // u tabeli questions ovo polja nazvati opt_scale25
        "0": "Almost certainly not", // u tabeli questions ovo polja nazvati opt_scale0
      };
      */
      backendizedQProps = {
        opt_scale100: null,
        opt_scale75: null,
        opt_scale50: null,
        opt_scale25: null,
        opt_scale0: null,
      };
      if (q.question_option_titles["100"]) { backendizedQProps.opt_scale100 = q.question_option_titles["100"]; } else { }
      if (q.question_option_titles["75"]) { backendizedQProps.opt_scale75 = q.question_option_titles["75"]; } else { }
      if (q.question_option_titles["50"]) { backendizedQProps.opt_scale50 = q.question_option_titles["50"]; } else { }
      if (q.question_option_titles["25"]) { backendizedQProps.opt_scale25 = q.question_option_titles["25"]; } else { }
      if (q.question_option_titles["0"]) { backendizedQProps.opt_scale0 = q.question_option_titles["0"]; } else { }
    }
    if (question_type === "ABC") {
      backendizedQProps = {
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
      };
      if (q.question_option_titles["A"]) { backendizedQProps.a = q.question_option_titles["A"]; } else { }
      if (q.question_option_titles["B"]) { backendizedQProps.b = q.question_option_titles["B"]; } else { }
      if (q.question_option_titles["C"]) { backendizedQProps.c = q.question_option_titles["C"]; } else { }
      if (q.question_option_titles["D"]) { backendizedQProps.d = q.question_option_titles["D"]; } else { }
      if (q.question_option_titles["E"]) { backendizedQProps.e = q.question_option_titles["E"]; } else { }
      if (q.question_option_titles["F"]) { backendizedQProps.f = q.question_option_titles["F"]; } else { }
      if (q.question_option_titles["G"]) { backendizedQProps.g = q.question_option_titles["G"]; } else { }
      if (q.question_option_titles["H"]) { backendizedQProps.h = q.question_option_titles["H"]; } else { }
      if (q.question_option_titles["I"]) { backendizedQProps.i = q.question_option_titles["I"]; } else { }
      if (q.question_option_titles["J"]) { backendizedQProps.j = q.question_option_titles["J"]; } else { }
    }
    if (question_type === "CHECKLIST") {
      backendizedQProps.checklist = [];
      q.question_checklist.forEach((c_item) => {
        backendizedQProps.checklist.push(c_item);
      });
    }
    //
    //
    if (typeof q.question_type === 'string') {
      question_type = q.question_type.toLowerCase(); // TODO
    } else {
      question_type = null;
    }
    /*
    table
      .enu("question_type", [
        "text",
        "yesno",
        "scale",
        "stars",
        "abc",
        "checklist",
      ])
      .notNullable();
    */
    if (question_type === "yes_no") {
      question_type = "yesno";
    }
    if (question_type === "stars_5") {
      question_type = "stars";
    }
    if (question_type === "scale_5") {
      question_type = "scale";
    }
    // TODO za SCALE_5 opcije...
    //
    // --- TODO
    //
    let backendizedQuestion = {
      // ...q,
      ..._zzsurvey_utils_singleQuestionState_to_extra_answer_props(q),
      ...backendizedQProps,
      title: q.title,
      question_type, // TODO
      required: required,
    };
    delete backendizedQuestion.tempkey;
    return backendizedQuestion;
  });
  //
  // NOVO 2025-07-12
  if (editorQuizState?.header?._by_email_or_direct === "WITHOUT_EMAIL") { // CASE without email
    // deleting email fields
    delete prepared.first_email_title;
    delete prepared.first_email_content;
    delete prepared.second_email_title;
    delete prepared.second_email_content;
  } else { // CASE with email fields
    // no changes
  }
  delete prepared._by_email_or_direct;
  //
  // console.log('data prepared for SUBMIT', prepared);
  return prepared;
};


//
const QuestionAbc = (props) => {
  const {
    item,
    _handleEditorQuestionOptionTitlesChange,
  } = props;
  const {
    tempkey,
    question_option_titles,
  } = item;
  //
  let _options = [];
  const abc_keys_string = "ABCDEFGHIJ";
  //
  return (
    <div className="zzsurvey__question">
      <div className="zzsurvey__question-abc">
        <div>Fill titles for options:</div>
        <table className="zzsurvey__table-question-titles uu-anytable--zebra-rows-odd">
          <thead>
            <tr>
              <th>opt.</th>
              <th>title</th>
              <th>{config_condition_feature_enabled ? ('Condition') : (null)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              Object.keys(question_option_titles).map((key, index) => {
                const val = question_option_titles[key];
                return (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>
                      <FormFieldGenerator
                        fieldDefinition={{
                          "type": "input_text",
                          "params": {
                            // "readonly": true,
                            "label": "title_",
                            "name": "title_",
                            // "w": 75
                          }
                        }}
                        value={val}
                        handleChange={(e) => { _handleEditorQuestionOptionTitlesChange(e, tempkey, key) }}
                      />
                    </td>
                    <td>{config_condition_feature_enabled ? ('Condition') : (null)}</td>
                    <td></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

//
const QuestionScale5 = (props) => {
  const {
    item,
    _handleEditorQuestionOptionTitlesChange,
  } = props;
  const {
    tempkey,
    question_option_titles,
    extra_answer_condition,
    _extra_answer_condition_enabled,
  } = item;
  //
  const scale5_keys_arr = [100, 75, 50, 25, 0];
  //
  return (
    <div className="zzsurvey__question">
      <div className="zzsurvey__question-scale5">
        <div>Fill titles for options:</div>
        <table className="zzsurvey__table-question-titles uu-anytable--zebra-rows-odd">
          <thead>
            <tr>
              <th>%</th>
              <th>title</th>
              <th>{config_condition_feature_enabled ? ('Condition') : (null)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              scale5_keys_arr.map((key, index) => {
                // Object.keys(question_option_titles).map((key, index) => {
                const val = question_option_titles[key];
                return (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>
                      <FormFieldGenerator
                        fieldDefinition={{
                          "type": "input_text",
                          "params": {
                            // "readonly": true,
                            "label": "title_",
                            "name": "title_",
                            // "w": 75
                          }
                        }}
                        value={val}
                        handleChange={(e) => { _handleEditorQuestionOptionTitlesChange(e, tempkey, key) }}
                      />
                    </td>
                    <td>
                      {config_condition_feature_enabled ? ('Condition') : (null)}
                      {/*
                      <FormFieldGenerator
                        fieldDefinition={{
                          "type": "input_radio_group",
                          "params": {
                            // "readonly": true,
                            "label": "condition",
                            "name": "title_",
                            // "w": 75
                          }
                        }}
                        value={key}
                        handleChange={() => { }}
                      />
                      */}
                    </td>
                    <td></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

//
const QuestionChecklist = (props) => {
  const {
    item,
    // _handleEditorQuestionOptionTitlesChange,
    _handleEditorQuestionChecklist_CrudAdd,
    _handleEditorQuestionChecklist_CrudUpdate,
    _handleEditorQuestionChecklist_CrudDelete,
  } = props;
  const {
    tempkey,
    // question_option_titles,
    question_checklist,
    extra_answer_condition,
    _extra_answer_condition_enabled,
  } = item;
  //
  const scale5_keys_arr = [100, 75, 50, 25, 0];
  //
  return (
    <div className="zzsurvey__question">
      <div className="zzsurvey__question-checklist">
        <div>Fill titles for options:</div>
        <table className="zzsurvey__table-question-titles uu-anytable--zebra-rows-odd">
          <thead>
            <tr>
              <th>#</th>
              <th>title</th>
              <th>{config_condition_feature_enabled ? ('Condition') : (null)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              question_checklist.map((key, index) => {
                // Object.keys(question_option_titles).map((key, index) => {
                //const val = question_option_titles[key];
                const val = key;
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <FormFieldGenerator
                        fieldDefinition={{
                          "type": "input_text",
                          "params": {
                            // "readonly": true,
                            "label": "title_",
                            "name": "title_",
                            // "w": 75
                          }
                        }}
                        value={val}
                        handleChange={(e) => { _handleEditorQuestionChecklist_CrudUpdate(e, tempkey, index) }}
                      />
                    </td>
                    <td>
                      {config_condition_feature_enabled ? ('Condition') : (null)}
                      {/*
                      <FormFieldGenerator
                        fieldDefinition={{
                          "type": "input_radio_group",
                          "params": {
                            // "readonly": true,
                            "label": "condition",
                            "name": "title_",
                            // "w": 75
                          }
                        }}
                        value={key}
                        handleChange={() => { }}
                      />
                      */}
                    </td>
                    <td>
                      <Btn
                        inline
                        circle
                        outline
                        btnSmall
                        i={'fa fa-trash-o'}
                        handleClick={(e) => { _handleEditorQuestionChecklist_CrudDelete(e, tempkey, index) }}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <div>
          <Btn
            inline
            circle
            outline
            btnSmall
            i={'fa fa-plus'}
            handleClick={(e) => { _handleEditorQuestionChecklist_CrudAdd(e, tempkey); }}
          />
        </div>
      </div>
    </div>
  );
};


//
//
const _demo_initialQuizEditorState_v1 = _zzsurvey_utils_dummyResPayload_v1_to_quizEditorState(_zzsurvey_dummy_res_v1.payload);
//
const _demo_initialQuizEditorState_v2_make = () => {
  return _zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(_zzsurvey_utils_demo_res_v2_make());
};
//
//
const _extract_header_from_initialQuizEditorState = (initialQuizEditorState) => {
  return {
    internal_name: initialQuizEditorState.internal_name,
    title: initialQuizEditorState.title,
    survey_text: initialQuizEditorState.survey_text,
    survey_img_src: initialQuizEditorState.survey_img_src,
    // date_due: '2030-12-31',
    service_type: initialQuizEditorState.service_type,
    _by_email_or_direct: initialQuizEditorState._by_email_or_direct, // NOVO 2025-07-12
    first_email_title: initialQuizEditorState.first_email_title,
    first_email_content: initialQuizEditorState.first_email_content,
    second_email_title: initialQuizEditorState.second_email_title,
    second_email_content: initialQuizEditorState.second_email_content,
    is_review: initialQuizEditorState.is_review,
    review_text: initialQuizEditorState.review_text,
    review_link: initialQuizEditorState.review_link,
    //
    // survey_template_id: backendQuizBlueprint.survey_template_id, // TODO
    is_anonymous: initialQuizEditorState.is_anonymous, // NEW
  };
};
//
export const ZZTempSurveyQuizEditorContainer = (props) => {
  const {
    mode,
    cbSubmit,
    cbCancel,
    templateEntityToClone,
  } = props;
  let initialQuizEditorState = null;
  if (mode === 'DEMO') {
    console.log('mode DEMO');
    // initialQuizEditorState = _demo_initialQuizEditorState_v1;
    initialQuizEditorState = _demo_initialQuizEditorState_v2_make();
  } else if (mode === 'CLONE') {
    initialQuizEditorState = _zzsurvey_utils_backendQuizBlueprint_to_quizEditorState(templateEntityToClone);
  } else {
    initialQuizEditorState = _zzsurvey_utils_quizEditorState_initial_blank_make();
  }
  const [editorQuizHeader, handleChangeQuizHeader, setEditorQuizHeader] = useHandleInputChange(_extract_header_from_initialQuizEditorState(initialQuizEditorState));
  const [editorQuizQuestions, setEditorQuizQuestions] = useState(initialQuizEditorState.questions);

  const editorQuizState = { // TODO
    header: editorQuizHeader,
    questions: editorQuizQuestions,
  };

  const quizEditorPack = {
    editorQuizHeader, handleChangeQuizHeader, setEditorQuizHeader,
    editorQuizQuestions, setEditorQuizQuestions,
    editorQuizState,
  };

  //
  // const quizBlueprint = dummy_res.payload;
  const quizBlueprintPreview = _zzsurvey_utils_quizEditorState_to_quizBlueprint_preview(editorQuizHeader, editorQuizQuestions, mode);
  console.log('quizBlueprint preview', quizBlueprintPreview);

  return (
    <>
      {/*
      <div>
        <SpinnerClassic />
      </div>
      */}
      <div className="zzsurvey__quiz-editor-and-preview-pair">
        <div className="zzsurvey__quiz-editor-and-preview-pair__col">
          <ZZTempSurveyQuizEditor
            quizEditorPack={quizEditorPack}
            cbSubmit={cbSubmit}
            cbCancel={cbCancel}
          />
        </div>
        <div className="xzzsurvey__quiz-editor-and-preview-pair__col">
          <h2>Preview - Quiz fill/answers</h2>
          <ZZTempSurveyQuizFill
            mode={'LIVE_PREVIEW'}
            quiz_key={null}
            quizBlueprint={quizBlueprintPreview}
            cbSubmit={() => { window.alert('This is just a preview :)'); }}
          />
        </div>
      </div>
    </>
  );
};


//
const ZZTempSurveyQuizEditor = (props) => {
  const {
    quizEditorPack,
    cbSubmit, // TODO
    cbCancel,
  } = props;
  const {
    editorQuizHeader, handleChangeQuizHeader, setEditorQuizHeader,
    editorQuizQuestions, setEditorQuizQuestions,
    editorQuizState,
  } = quizEditorPack;
  const ACCEPT_FILE_TYPES_IMG = "image/*";
  const ACCEPT_FILE_TYPES_IMG_JPG_PNG = "image/jpeg, image/png";
  const [imgSrcBlob, setImgSrcBlob] = useState(editorQuizHeader.survey_img_src);

  useEffect(() => {
    console.log('*** header state', editorQuizHeader);
    setEditorQuizHeader({
      ...editorQuizHeader,
      survey_img_src: imgSrcBlob
    });
  }, [imgSrcBlob]);

  //
  const handleInputFileChange = (e) => {
    // ovo je poseabn handler samo za onChange na input type="file" polju
    // console.log('handleInputFileChange(e) ');
    // console.log(e);
    const target = e.target;
    // posto input polje za fajl moze da primi vise fajlova...
    // console.log(target.files.length);
    // let dom_el = inputFileRef.current; // reference to a DOM input file element
    // if (dom_el) {
    if (target) {
      // let target = dom_el;
      const files = target.files;
      console.log(files);
      console.log(files.length);
      if (files.length > 0) {
        const selectedFile = files[0];
        // const selectedFile = target.files[0];
        if (selectedFile) { // znaci da je odabran najmanje jedan fajl
          const reader = new FileReader(); // napravi novu instancu klase FileReader
          // reader.onload = function (e) {
          const handleLoad = (e) => {
            console.log('--- FileReader .onload (event "load")');
            console.log(e);
            console.log('uspesno se zavrsilo ucitavanje fajla');
            const blob = reader.result; // dobil ismo blob ucitanog fajla slike
            // upisujemo gotov blob u nas state
            // setImageBlob(blob);
            setImgSrcBlob(blob);
            /*
            if (e.target && e.target.result) {
              const raw = e.target.result;
              console.log('typeof e.target.result', typeof e.target.result);
              console.log('e.target.result', raw);
              try {
 
              } catch (err) {
                console.log('error catch while ______ file', err);
              }
            }
            */
          };
          reader.addEventListener("load", handleLoad);
          reader.readAsDataURL(selectedFile); // zapocinje citanje fajla u formatu slike koji moze da se koristi u src od slike
        }
      }
    }
  };

  //
  const _handleEditorQuestionType = (index, value) => {
    const updatedState = editorQuizQuestions.map((item, i) => {
      if (i === index) {
        if (item.question_type === value) {
          return item;
        } else {
          return _zzsurvey_utils_initial_singleQuestionState_make(value, item);
        }
      }
      return item;
    });
    setEditorQuizQuestions(updatedState);
  };

  //
  const _handleEditorQuestionChange = (event, tempkey) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (name === "question_type") { // do nothing
      return;
    } else {
      const updatedState = editorQuizQuestions.map((item, i) => {
        if (item.tempkey === tempkey) {
          return {
            ...item,
            [name]: value
          };
        }
        return item;
      });
      setEditorQuizQuestions(updatedState);
    }
  };


  //
  const _handleEditorQuestionOptionTitlesChange = (event, tempkey, option_key) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const updatedState = editorQuizQuestions.map((item, i) => {
      if (item.tempkey === tempkey) {
        const updatedOptionTitles = { ...item.question_option_titles };
        updatedOptionTitles[option_key] = value;
        return {
          ...item,
          question_option_titles: updatedOptionTitles
        };
      }
      return item;
    });
    setEditorQuizQuestions(updatedState);
  };


  //
  const _handleEditorQuestionChecklist_CrudAdd = (event, tempkey) => {
    /*
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    */
    const updatedState = editorQuizQuestions.map((item, i) => {
      if (item.tempkey === tempkey) {
        const question_checklist = [...item.question_checklist, null];
        return {
          ...item,
          question_checklist: question_checklist
        };
      }
      return item;
    });
    setEditorQuizQuestions(updatedState);
  };
  //
  const _handleEditorQuestionChecklist_CrudUpdate = (event, tempkey, option_index) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const updatedState = editorQuizQuestions.map((item, i) => {
      if (item.tempkey === tempkey) {
        const question_checklist = item.question_checklist.map((opt, opt_i) => {
          if (opt_i === option_index) {
            return value;
          }
          return opt;
        });
        return {
          ...item,
          question_checklist: question_checklist
        };
      }
      return item;
    });
    setEditorQuizQuestions(updatedState);
  };
  //
  const _handleEditorQuestionChecklist_CrudDelete = (event, tempkey, option_index) => {
    /*
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    */
    const updatedState = editorQuizQuestions.map((item, i) => {
      if (item.tempkey === tempkey) {
        const question_checklist = item.question_checklist.filter((opt, opt_i) => {
          if (opt_i === option_index) {
            return false; // delete
          }
          return true; // all other stay
        });
        return {
          ...item,
          question_checklist: question_checklist
        };
      }
      return item;
    });
    setEditorQuizQuestions(updatedState);
  };


  //
  /*
  const _handleEditorExtraConditionhange = (tempkey, condition) => {
    if (condition !== null) {
      
    }
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (name === "question_type") { // do nothing
      return;
    } else {
      const updatedState = editorQuizQuestions.map((item, i) => {
        if (item.tempkey === tempkey) {
          return {
            ...item,
            [name]: value
          };
        }
        return item;
      });
      setEditorQuizQuestions(updatedState);
    }
  };
  */


  //
  const _crudQuestionDelete = (target_tempkey) => {
    const updatedState = editorQuizQuestions.filter((item, i) => {
      if (item.tempkey === target_tempkey) {
        return false; // delete target
      }
      return true; // all other stay
    });
    setEditorQuizQuestions(updatedState);
  };
  //
  const _crudQuestionMove = (target_index, to_prev) => {
    const updatedState = [];
    if (to_prev === true) { // to prev
      if (target_index === 0) { // imposible move
        return; // EXIT
      }
    } else { // to next
      if (target_index > (editorQuizQuestions.length - 2)) { // imposible move
        return; // EXIT
      }
    }
    let skip_me = false;
    editorQuizQuestions.forEach((item, index) => {
      if (to_prev === true) { // to prev
        if (index === (target_index - 1)) {
          const next_item = editorQuizQuestions[target_index];
          updatedState.push(next_item);
          updatedState.push(item);
          skip_me = true;
        } else {
          if (skip_me) {
            // do nothing
            skip_me = false;
          } else {
            updatedState.push(item);
          }
        }
      } else { // to next
        if (index === target_index) {
          const prev_item = editorQuizQuestions[index + 1];
          updatedState.push(prev_item);
          updatedState.push(item);
          skip_me = true;
        } else {
          if (skip_me) {
            // do nothing
            skip_me = false;
          } else {
            updatedState.push(item);
          }
        }
      }
    });
    //
    setEditorQuizQuestions(updatedState);
  };
  //
  const _crudQuestionAdd = () => {
    const updatedState = [...editorQuizQuestions, _zzsurvey_utils_initial_singleQuestionState_make(null, null, true)];
    setEditorQuizQuestions(updatedState);
  };

  const handleClickSubmit = (e) => {
    const entbox = _prepare_for_submit_questions(editorQuizState);
    console.log('data prepared for SUBMIT', entbox);
    if (typeof cbSubmit === 'function') {
      cbSubmit(entbox);
    }
  };

  return (
    <>
      <div className="zzsurvey__quiz-editor">
        <h1>Quiz editor</h1>
        <h3>Edit quiz header</h3>
        <div className="zzsurvey__card">
          <FormGenerator
            formDefinition={_zzsurvey_formDefiinitionSurveyHeader(editorQuizHeader)}
            formState={editorQuizHeader}
            formErrors={{}}
            handleChange={handleChangeQuizHeader}
          />
          <div className="uniformcompo__field">
            <div className="zzsurvey__quiz-editor__input-file">
              <label className="file-input-custom-design">
                <span className="icon"><i className="fa fa-picture-o" aria-hidden="true"></i></span>
                <span>Add survey image (logo)</span>
                <input
                  type="file"
                  accept={ACCEPT_FILE_TYPES_IMG}
                  name="file"
                  onChange={handleInputFileChange}
                />
              </label>
            </div>
            <div className="zzsurvey__quiz-editor__header__img-widget">
              {
                imgSrcBlob && (
                  <div className="zzsurvey__quiz-editor__header__img-preview"><img src={imgSrcBlob} /></div>
                )
              }
              {
                imgSrcBlob !== null && (
                  <Btn
                    inline
                    circle
                    outline
                    btnSmallWithTitle
                    title="Delete image"
                    i={'fa fa-trash'}
                    handleClick={() => { setImgSrcBlob(null); }}
                  />
                )
              }
            </div>
          </div>
        </div>

        <h3>Edit quiz questions</h3>
        <div className="zzsurvey__editor__questions">
          {
            editorQuizQuestions.map((item, index) => {
              const question_type = item.question_type;
              return (
                <div key={index} className="zzsurvey__card">
                  <div className="vector row gaps zzsurvey__editor__bar">
                    <div className="xi"><b>#{(index + 1)}</b> edit question ({item.tempkey})</div>
                    <div className="xi">
                      <form>
                        <FormFieldGenerator
                          fieldDefinition={{
                            "type": "select",
                            "params": {
                              "label": "question_type",
                              "name": "question_type",
                              "default_option_title": "--select type--",
                              "options": [
                                { "title": "TEXT", "value": "TEXT" },
                                { "title": "YES_NO", "value": "YES_NO" },
                                { "title": "STARS_5", "value": "STARS_5" },
                                { "title": "SCALE_5", "value": "SCALE_5" },
                                { "title": "ABC", "value": "ABC" },
                                { "title": "CHECKLIST", "value": "CHECKLIST" },
                              ],
                              // "outline": true,
                              // "extraclass": "novo-radios-row",
                            }
                          }}
                          value={question_type}
                          handleChange={(e) => { _handleEditorQuestionType(index, e.target.value) }}
                        />
                      </form>
                    </div>
                    <div className="xi zzsurvey__editor__bar__btns">
                      <Btn
                        inline
                        circle
                        outline
                        btnSmall
                        i={'fa fa-arrow-up'}
                        handleClick={() => { _crudQuestionMove(index, true); }}
                      />
                      <Btn
                        inline
                        circle
                        outline
                        btnSmall
                        i={'fa fa-arrow-down'}
                        handleClick={() => { _crudQuestionMove(index, false); }}
                      />
                      <Btn
                        inline
                        circle
                        outline
                        btnSmall
                        i={'fa fa-trash'}
                        handleClick={() => { _crudQuestionDelete(item.tempkey); }}
                      />
                    </div>
                  </div>
                  <form>
                    {
                      typeof question_type === 'string' && question_type !== '' ? (
                        <div>
                          <FormGenerator
                            formDefinition={_zzsurvey_formDefiinitionSingleQuestion_make(item)}
                            formState={item}
                            formErrors={{}}
                            handleChange={(e) => { _handleEditorQuestionChange(e, item.tempkey) }}
                          />
                        </div>
                      ) : (
                        <div className="zzsurvey__editor__error-msg">You must select question type</div>
                      )
                    }
                    {
                      question_type === "ABC" && (
                        <div className="xi">
                          <QuestionAbc
                            item={item}
                            _handleEditorQuestionOptionTitlesChange={_handleEditorQuestionOptionTitlesChange}
                          />
                        </div>
                      )
                    }
                    {
                      question_type === "SCALE_5" && (
                        <div className="xi">
                          <QuestionScale5
                            item={item}
                            _handleEditorQuestionOptionTitlesChange={_handleEditorQuestionOptionTitlesChange}
                          />
                        </div>
                      )
                    }
                    {
                      question_type === "CHECKLIST" && (
                        <div className="xi">
                          <QuestionChecklist
                            item={item}
                            _handleEditorQuestionChecklist_CrudAdd={_handleEditorQuestionChecklist_CrudAdd}
                            _handleEditorQuestionChecklist_CrudUpdate={_handleEditorQuestionChecklist_CrudUpdate}
                            _handleEditorQuestionChecklist_CrudDelete={_handleEditorQuestionChecklist_CrudDelete}
                          />
                        </div>
                      )
                    }
                  </form>
                </div>
              );
            })
          }
        </div>

        <div>
          <div className="uu-gap-standalone-16px"></div>
          <Btn
            inline
            circle
            title="Add question"
            i={'fa fa-plus'}
            handleClick={() => { _crudQuestionAdd(); }}
          />
        </div>

        <div className="zzsurvey__quiz__footer">
          <div className="unicompo-dialog__btns unicompo-dialog__btns--sticky">
            <div className="unicompo-dialog__btns__btn-pack-vector">
              <div className="xi">
                <Btn
                  title='Submit quiz'
                  btnDialogSubmit
                  handleClick={handleClickSubmit}
                  disabled={false}
                />
              </div>
              <div className="xi">
                <Btn
                  outline
                  btnDialogCancel
                  title='Cancel'
                  i='fa fa-times'
                  handleClick={() => { cbCancel(); }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZZTempSurveyQuizEditor;